import { faArrowRightArrowLeft, faTrash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { WingmanAdminDocumentIndentifier } from "../models/WingmanAdminDocument";
import { canEdit } from "../utils/helpers";

const WingmanAdminTableCtrls = ({
  id,
  fileName,
  handleDelete,
  handleReplace,
  handleClear,
  uploadStatus,
  authorizedBrands,
  brands,
}: {
  id: number;
  fileName: string;
  handleDelete: (payload: WingmanAdminDocumentIndentifier) => void;
  handleReplace: (payload: WingmanAdminDocumentIndentifier) => void;
  handleClear: (payload: WingmanAdminDocumentIndentifier) => void;
  uploadStatus: string;
  authorizedBrands: string[];
  brands: string[];
}) => {
  const userCanEdit = canEdit(authorizedBrands, brands);
  const disabled = uploadStatus === "Complete" && !userCanEdit;

  const onDelete = () => {
    handleDelete({ Filename: fileName, id: id });
  };

  const onReplace = () => {
    handleReplace({ Filename: fileName, id: id });
  };

  const onClear = () => {
    handleClear({ Filename: fileName, id: id });
  };

  return (
    <div>
      {uploadStatus === "Complete" ? (
        <div className="flex gap-2 justify-center">
          <FontAwesomeIcon title={t("Delete")} className={`text-unleashed-pink hover:saturate-200 transition ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`} icon={faTrash} onClick={disabled ? undefined : onDelete} />
          <FontAwesomeIcon title={t("Replace")} className={`text-unleashed-pink hover:saturate-200 transition ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`} icon={faArrowRightArrowLeft} onClick={disabled ? undefined : onReplace} />
        </div>
      ) : uploadStatus === "Incomplete" || uploadStatus === "Ready" ? (
        <div className="flex flex-col justify-center">
          <button title={t("Clear")} className="text-unleashed-pink hover:saturate-200 transition cursor-pointer" onClick={onClear}>Clear</button>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default WingmanAdminTableCtrls;